import { Component, Input, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-search-dropdown',
  templateUrl: './search-dropdown.component.html',
  styleUrls: ['./search-dropdown.component.scss']
})
export class SearchDropdownComponent {


  public show: boolean = false;
  public originalList: any[];
  public dropdownList: any[] = []; 

  public _displayParameter: string = '';
  public searchText: string = '';
  public multiPlantSelected: boolean = false;



  @Input() set displayParameter(value: string) {
    this._displayParameter = value;
  }

  @Input() multiple: boolean = false;
  @Input() dropdownName: string;

  @Input() showSearch: boolean = true;
  @Output() selectOption = new EventEmitter<{dropdownName: string, option: any}>();
  @Output() closeOptionsMenu = new EventEmitter<void>();


  @Input() set items(values: any[]) {
    if(this.multiple) {
      this.originalList = values.map(val => {
        val['isChecked'] = false;
        return {...val};
      })

      this.dropdownList = [...this.originalList]
    } else {
      this.originalList = [...values];
      this.dropdownList = [...values];
    }

    if(values.length > 0 && typeof values[0] === 'object' && this._displayParameter === '') {
      let firstObj = values[0]
      this._displayParameter = Object.keys(firstObj)[0];
    }
  }

  public onSelectOption(option: string): void{
    this.selectOption.emit({dropdownName: this.dropdownName, option});
  }

  public onSelectMultiOption(option: string): void{
    let selectedOptions = this.dropdownList.filter(list => list.isChecked);

    this.selectOption.emit({dropdownName: this.dropdownName, option: selectedOptions})
  }


  public filterItems(value: any) {
    
    if(value !== '') {
      this.dropdownList = this.originalList.filter(item => {
        if(this._displayParameter === '') {
          return item.toLowerCase().includes(value.toLowerCase());
        } else {
          return item[this._displayParameter].toLowerCase().includes(value.toLowerCase());
        }
      
      })
    } else {
      this.dropdownList = [...this.originalList];
    }
  }
}
